var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['blw-spinner', { 'full-page': _vm.fullPage, 'app-loader': _vm.appLoader }]},[(_vm.fullPage)?[_c('v-layout',{attrs:{"fill-height":"","justify-center":"","align-center":""}},[_c('v-progress-circular',_vm._b({},'v-progress-circular',_vm.$props,false))],1)]:_c('v-progress-circular',_vm._b({},'v-progress-circular',_vm.$props,false))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }